"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSelectors = void 0;
var react_redux_1 = require("react-redux");
var mapSelectors = function () {
    return (0, react_redux_1.useSelector)(function (state) { return ({
        fileHistory: state.order.wizard.fileHistory,
        checkingFiles: state.order.wizard.checkingFiles,
        values: state.order.wizard.values,
        cart: state.cart,
        enableRestore: state.order.wizard.fileHistory.enableRestore,
        currentFrame: state.order.wizard.fileHistory.currentFrame,
        orderFilesStatus: state.order.wizard.orderFilesStatus,
        isSaving: state.order.wizard.isSaving,
        files: state.order.wizard.checkingFiles.files,
        token: state.auth.current.token,
        selectedFiles: state.order.wizard.fileHistory.selectedFiles,
        history: state.order.wizard.fileHistory.history,
        historyBrowsed: state.order.wizard.fileHistory.historyBrowsed
    }); });
};
exports.mapSelectors = mapSelectors;
